export interface ChildrenItems {
  state: string;
  name: string;
  type: string;
  visibility: boolean;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  visibility: boolean;
  children?: ChildrenItems[];
}

export const MENU_ITEM_TYPE = {
  EXT: 'extLink',
  LINK: 'link',
  SUB: 'sub'
};
